import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-parent">
      <div className="flex flex-row footer-container">
        <div className="basis-1/2 text-white text-5xl text-left">
          {/* Together, we can harmonise music with meaning */}
        </div>
        <div className="basis-1/2 footer-container">
          <div className="footer-list float-right text-white">
            <div className="footer-logo-div float-right logo mb-10">
              <a href="https://university.taylors.edu.my/en.html">
                <img
                  src={require("../../Assets/logo.png")}
                  className="logo-footer"
                  alt="logofooter"
                />
              </a>
            </div>
            <div className="clearfix"></div>
            <div className="footer_link flex flex-col text-white">
              <a
                href="#moreThanJustMusic"
                className="text-lg paragraph registration-desc"
              >
                MORE THAN JUST MUSIC
              </a>
              <a
                href="#whatHappening"
                className="text-lg paragraph registration-desc"
              >
                WHAT’S HAPPENING
              </a>
              <a
                href="#specialAppearance"
                className="text-lg paragraph registration-desc"
              >
                SPECIAL APPEARANCES
              </a>
              <a
                href="#collaboration"
                className="text-lg paragraph registration-desc"
              >
                TAYLOR'S CLUBS COLLABORATION
              </a>
              <a href="#faq" className="text-lg paragraph registration-desc">
                FREQUENTLY ASKED QUESTIONS
              </a>
            </div>
            <div className="copyright mt-10">
              <p>© 2023 Taylor’s Education Group. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
